import { holdsActiveCustomModel } from '../../../../functions/client-model/client-node/holds-active-custom-model';
import { holdsActiveTransitionTargetData } from '../../../../functions/client-model/client-node/holds-active-transition-target-data';
import { ClientNode } from '../../../../model/client-model/client-node';

/**
 * Returns the id used for retrieving the calculation result for the given node.
 * Will return undefined if the node can't have a calculation result.
 * @param node
 */
export function getCalculationResultId(node: ClientNode): string | undefined {
  if (holdsActiveTransitionTargetData(node)) {
    return node.nodeProperties?.transitionTargetData?.transitionTargetProperties?.transitionElement;
  } else if (holdsActiveCustomModel(node)) {
    return node.id;
  }
}
